import { IsBoolean, IsEnum, IsString } from "class-validator";
import { MonitoringBomServiceId } from "./monitoring-bom-service-definition";

export class MonitoringBomService {
  @IsEnum(MonitoringBomServiceId)
  id: MonitoringBomServiceId;

  @IsBoolean()
  required: boolean;

  @IsString()
  notes: string;

  constructor(id: MonitoringBomServiceId, required: boolean = false, notes: string = "") {
    this.id = id;
    this.required = required;
    this.notes = notes;
  }

  static createDefaults(): MonitoringBomService[] {
    return [
      new MonitoringBomService(MonitoringBomServiceId.PROJECT_MANAGEMENT),
      new MonitoringBomService(MonitoringBomServiceId.CONSULTING),
      new MonitoringBomService(MonitoringBomServiceId.TRAINING),
      new MonitoringBomService(MonitoringBomServiceId.INSTALLATION_COMMISSIONING),
    ];
  }

  static createAll(values: Partial<MonitoringBomService>[] | undefined): MonitoringBomService[] {
    const defaults = this.createDefaults();
    if (!values?.length) {
      return defaults;
    }

    const valuesById = new Map(
      values
        .filter((value): value is Partial<MonitoringBomService> & { id: MonitoringBomServiceId } => value.id !== undefined)
        .map((value) => [value.id, { required: value.required === true, notes: value.notes ?? "" }]),
    );

    return defaults.map((entry) => {
      const value = valuesById.get(entry.id);
      return new MonitoringBomService(entry.id, value?.required ?? false, value?.notes ?? "");
    });
  }
}
